import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, onMounted, ref } from 'vue';

const MOBILE_QUERY = '(max-width: 992px)';


export default /*@__PURE__*/_defineComponent({
  __name: 'lk-mobile-notice-modal',
  setup(__props) {

const isOpen = ref(false);

const close = (): void => {
  isOpen.value = false;
};

const scrollModalIntoView = (): void => {
  requestAnimationFrame(() => {
    document.querySelector('.lk-mobile-notice-modal')?.scrollIntoView({
      block: 'center',
      inline: 'center',
    });
  });
};

onMounted(async () => {
  if (!window.matchMedia(MOBILE_QUERY).matches) return;

  isOpen.value = true;
  await nextTick();
  scrollModalIntoView();
});

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    open: isOpen.value,
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    centered: "",
    width: 400,
    class: "lk-mobile-notice-modal",
    footer: null,
    closable: true,
    "mask-closable": true,
    keyboard: true,
    onCancel: close
  }, {
    default: _withCtx(() => [
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "lk-mobile-notice-modal__text" }, " Для удобства работы в личном кабинете просим воспользоваться веб-версией портала ", -1)),
      _createElementVNode("div", { class: "lk-mobile-notice-modal__actions" }, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary btn-medium",
          onClick: close
        }, "ОК")
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})